export default __webpack_public_path__ + "images/printer.ba0e414beaabbd9f03724374d62ff626.svg";